
<div class="modal-header">
  <h4 class="modal-title ms-3">Delete Maintenance Item</h4>
  <button type="button" class="btn-close me-2" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body mx-3 mt-2 mb-3">
  
  <div class="alert alert-danger alert-outline-coloured" *ngIf="hasError">
    <div class="alert-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    </div>
    <div class="alert-message">
      <strong>Error occurred.</strong> There was problem deleting maintenance item.
    </div>
  </div>

  <p class="lh-md">Do you wish to delete the following maintenance item?</p>
  <div class="bg-light rounded-3 px-3 py-2">
    <table class="table table-sm table-no-bottom-border mb-0">
      <tbody>
      <tr><th class="text-end w-50 pe-3">Date of Maintenance</th><td>{{ maintenance.date }}</td></tr>
      <tr><th class="text-end w-50 pe-3">KMs at this Date</th><td>{{ maintenance.kms.toLocaleString() }}</td></tr>
      <tr><th class="text-end w-50 pe-3">Maintenance Term</th><td>{{ maintenance.term.description }}</td></tr>
      <tr><th class="text-end w-50 pe-3">Max Term KMs</th><td>{{ maintenance.maxKms.toLocaleString() }}</td></tr>
      <tr><th class="text-end w-50 pe-3">Max KMs</th><td>{{ (maintenance.maxKms + maintenance.kms).toLocaleString() }}</td></tr>
      <tr><th class="text-end w-50 pe-3">User Entering Maintenance</th><td>{{ maintenance.userEnteringMaintenanceSchedule }}</td></tr>
      <tr><th class="text-end w-50 pe-3">Due Date</th><td>{{ maintenance.dueDate | date:'yyyy-MM-dd' }}</td></tr>
      </tbody>
    </table>
  </div>
  
</div>

<div class="modal-footer">
  <div class="px-3">
    <button [disabled]="isDeleting" class="btn btn-lg btn-outline-secondary me-3" (click)="closeModal()">Cancel</button>
    <button [disabled]="isDeleting" class="btn btn-lg btn-danger position-relative" (click)="deleteMaintenanceRecord()">
      <span
        class="spinner fade spinner-border spinner-border-sm position-absolute top-0 bottom-0 start-0 end-0 m-auto"
        role="status"
        [ngClass]="{'show': isDeleting}">
      </span>
      <span class="text fade show">Delete</span>
    </button>
  </div>
</div>
